export const SET_MATCHES = 'SET_MATCHES';
export const SET_FETCHED_MATCHES = 'SET_FETCHED_MATCHES';
export const SET_UNIT_MATCHES = 'SET_UNIT_MATCHES';
export const SET_UNIT_BY_PRODUCT = 'SET_UNIT_BY_PRODUCT';

const reducer = (state, action) => {
  switch (action.type) {
    case SET_MATCHES:
      return {
        ...state,
        matches: action.payload
      };
    case SET_UNIT_MATCHES:
      return {
        ...state,
        unitsMatches: action.payload
      };
    case SET_FETCHED_MATCHES:
      return {
        ...state,
        matches: action.payload,
        fetchedMatches: action.payload
      };
    case SET_UNIT_BY_PRODUCT:
      return {
        ...state,
        forceSetUnit: action.payload.ids?.reduce((acc, id) => {
          acc[id] = action.payload.unit;
          return acc;
        }, {})
      };

    default:
      return state;
  }
};

export default reducer;
